/* global DOMParser */

export default function SubsectionsPanel() {
  return {
    restrict: 'E',
    template: require('./subsections-panel.html'),
    scope: {
      policyDocumentId: '<',
      subsections: '<',
      permissions: '<',
    },
    controller: 'SubsectionsPanelController',
    controllerAs: 'subsectionsPanelVM',
    bindToController: true,
    replace: false,
    link(scope) {
      scope.stripHtml = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || '';
      };
    }
  };
}
